<template>
  <div class="main-body">
    <div class="header">用药记录</div>
    <div class="out">

      <div class="search2">
        <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="toggleModalAdd">添加</el-button>

        <download-excel
            class = "export-excel-wrapper"
            :fetch           = "fetchData"
            :fields          = "json_fields"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload"
            name = "用药记录.xls"
            style="display: inline-block;margin-left: 5px;">
          <el-button plain type="success" size="mini" icon="el-icon-download">导出</el-button>
        </download-excel>

        <div style="float:right;">

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button size="mini" style="margin-left:5px;float:right" plain type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" v-loading="loading"
                :height="th" border >

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="早餐用药：" v-if="props.row.listMedicationSchedulingMorningItemDTO !=null && props.row.listMedicationSchedulingMorningItemDTO.length>0 ">

                <!--                <el-tag v-for="(value,i) in props.row.listMedicationSchedulingMorningItemDTO" :key="i" style="margin-right: 5px">{{value.medicationGroupName}}</el-tag>-->

                <el-popover v-for="(value,i) in props.row.listMedicationSchedulingMorningItemDTO" :key="i"
                            placement="right"
                            width="160"
                            title="药品" style="margin-right: 5px;"
                            trigger="hover">

                  <div v-for="(value2,i2) in value.listMedicationItem" :key="i2">
                    <span>{{value2.name}}</span>
                  </div>

                  <el-tag type="success" slot="reference">{{value.medicationGroupName}}</el-tag>

                </el-popover>




              </el-form-item>
              <el-form-item label="中午用药：" v-if="props.row.listMedicationSchedulingNoonItemDTO != null && props.row.listMedicationSchedulingNoonItemDTO.length>0 ">

                <!--                <el-tag v-for="(value,i) in props.row.listMedicationSchedulingNoonItemDTO" :key="i" style="margin-right: 5px">{{value.medicationGroupName}}</el-tag>-->

                <el-popover v-for="(value,i) in props.row.listMedicationSchedulingNoonItemDTO" :key="i"
                            placement="right"
                            width="160"
                            title="药品" style="margin-right: 5px;"
                            trigger="hover">

                  <div v-for="(value2,i2) in value.listMedicationItem" :key="i2">
                    <span>{{value2.name}}</span>
                  </div>

                  <el-tag type="success" slot="reference">{{value.medicationGroupName}}</el-tag>

                </el-popover>


              </el-form-item>
              <el-form-item label="晚上用药：" v-if="props.row.listMedicationSchedulingNightItemDTO!=null && props.row.listMedicationSchedulingNightItemDTO.length>0 ">

                <!--                <el-tag v-for="(value,i) in props.row.listMedicationSchedulingNightItemDTO" :key="i" style="margin-right: 5px">{{value.medicationGroupName}}</el-tag>-->

                <el-popover v-for="(value,i) in props.row.listMedicationSchedulingNightItemDTO" :key="i"
                            placement="right"
                            width="160"
                            title="药品" style="margin-right: 5px;"
                            trigger="hover">

                  <div v-for="(value2,i2) in value.listMedicationItem" :key="i2">
                    <span>{{value2.name}}</span>
                  </div>

                  <el-tag type="success" slot="reference">{{value.medicationGroupName}}</el-tag>

                </el-popover>


              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>
        <el-table-column prop="recordType" label="用药人">
          <template slot-scope="scope">
            <span v-if="scope.row.recordType == 'mediciner'">[医生]{{scope.row.medicinerName}}</span>
            <span v-if="scope.row.recordType == 'nurse'">[护士]{{scope.row.nurseName}}</span>
            <span v-if="scope.row.recordType == 'nurseAide'">[护工]{{scope.row.nurseAideName}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="timeType" label="类型"></el-table-column>

        <el-table-column prop="createTime" :formatter="formatTime" label="用药时间"></el-table-column>


      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
         v-on:getList="getList" v-bind:arr_ins="arr_ins" ></Add>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Add from "./Add";

export default {
  name: "Page",
  data(){
    return{
      loading:false,
      showModalAdd:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      arr_ins:[],
      institutionCode: '',

      type:3,

      showModal:false,
      json_fields: {

        "老人姓名": "elderlyName",
        "用药人": {
          callback:value=>{

            let recordType = value.recordType;

            let title = "";
            if(recordType == "mediciner"){
              title = "[医生]"+value.medicinerName;
            }
            if(recordType == "nurse"){
              title = "[护士]"+value.nurseName;
            }
            if(recordType == "nurseAide"){
              title = "[护工]"+value.nurseAideName;
            }

            return title;
          }
        },
        "用药药品": {
          callback:value=>{

            let title = "";

            if(value.listMedicationSchedulingMorningItemDTO !=null && value.listMedicationSchedulingMorningItemDTO.length>0){

              let ss = "";
              for(let i=0;i<value.listMedicationSchedulingMorningItemDTO.length;i++){

                let item = value.listMedicationSchedulingMorningItemDTO[i];
                ss+= item.medicationGroupName;

                let dd = "";
                for(let j=0;j<item.listMedicationItem.length;j++) {
                  dd += item.listMedicationItem[j].name+",";
                }
                ss += "["+dd+"]";

              }

              title += ss;
            }

            if(value.listMedicationSchedulingNoonItemDTO !=null && value.listMedicationSchedulingNoonItemDTO.length>0){

              let ss = "";
              for(let i=0;i<value.listMedicationSchedulingNoonItemDTO.length;i++){

                let item = value.listMedicationSchedulingNoonItemDTO[i];
                ss+= item.medicationGroupName;

                let dd = "";
                for(let j=0;j<item.listMedicationItem.length;j++) {
                  dd += item.listMedicationItem[j].name+",";
                }
                ss += "["+dd+"]";

              }

              title += ss;
            }

            if(value.listMedicationSchedulingNightItemDTO !=null && value.listMedicationSchedulingNightItemDTO.length>0){

              let ss = "";
              for(let i=0;i<value.listMedicationSchedulingNightItemDTO.length;i++){

                let item = value.listMedicationSchedulingNightItemDTO[i];
                ss+= item.medicationGroupName;

                let dd = "";
                for(let j=0;j<item.listMedicationItem.length;j++) {
                  dd += item.listMedicationItem[j].name+",";
                }
                ss += "["+dd+"]";

              }

              title += ss;
            }


            return title;
          }
        },
        "用药类型": "timeType",
        "时间": {
          field:"createTime",
          callback:value=>{
            return timefilters(value);
          }
        },

      },


    }
  },
  components:{
    Add
  },
  created(){
    this.getIns();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.type,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },




    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init(this.type);
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationRecord/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          institutionCode:this.institutionCode,
        }
      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },



    formatTime:function (row, column, cellValue) {
      return timefilters(cellValue);
    },


    async fetchData(){

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        institutionCode:this.institutionCode,
        pageIndex:1,
        pageSize:99999,
      }

      const response = await this.$axios.post(this.$shopUrl + "MedicationRecord/GovPage",data);
      let list = response.data.data.pageInfo.list;
      if(list.length==0){
        this.$message.info("数据为空");
        this.showModal = false;
      }
      return list;
    },

    startDownload:function (){
      this.showModal = true;
    },

    finishDownload:function (){
      this.showModal = false;
    },

  }
}
</script>

<style lang="scss" scoped>


</style>
